import React from 'react';
import styled from 'styled-components';

const SectionBreakDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`;

const PointP = styled.p`
  margin: 0 10px;
  font-size: 6px;
  text-align: center;
  justify-content: center;
  height: 7px;
`;

const SectionBreak = () => {
  return (
    <SectionBreakDiv>
      <PointP>{'\u2B24'}</PointP>
      <PointP>{'\u2B24'}</PointP>
      <PointP>{'\u2B24'}</PointP>
    </SectionBreakDiv>
  );
};

export default SectionBreak;
